const palette: Array<{ bg: string; text: string }> = [
  { bg: '#FFEDE3', text: '#7A2208' }, // accent / coral
  { bg: '#E8F0FF', text: '#1E3A8A' }, // blue
  { bg: '#E7F5EC', text: '#15543A' }, // green
  { bg: '#F5E8FF', text: '#5B2A8A' }, // purple
  { bg: '#FFF3D6', text: '#7A4E0E' }, // yellow
  { bg: '#FDE5EC', text: '#7A1C3E' }, // pink
  { bg: '#E4F2F4', text: '#0E4F58' }, // teal
];

export function tagColor(tag: string): { bg: string; text: string } {
  let h = 0;
  for (let i = 0; i < tag.length; i++) h = (h * 31 + tag.charCodeAt(i)) | 0;
  const idx = Math.abs(h) % palette.length;
  return palette[idx]!;
}
